import { Link, useLocation } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

function buildCrumbs(pathname: string): Crumb[] {
  const crumbs: Crumb[] = [{ label: "IR", to: "/ir" }];

  if (pathname.startsWith("/ir/dataroom")) {
    crumbs.push({ label: "Dataroom", to: "/ir/dataroom" });

    if (pathname === "/ir/dataroom/nda") {
      crumbs.push({ label: "NDA" });
    } else if (pathname.startsWith("/ir/dataroom/docs")) {
      crumbs.push({ label: "Documents", to: "/ir/dataroom/docs" });

      const match = pathname.match(/^\/ir\/dataroom\/docs\/(.+)$/);
      if (match?.[1]) {
        crumbs.push({ label: match[1] });
      }
    }
  } else if (pathname.startsWith("/ir/portal")) {
    crumbs.push({ label: "Portal" });
  }

  return crumbs;
}

export function IRSubNav() {
  const { pathname } = useLocation();
  const crumbs = buildCrumbs(pathname);

  // Find the parent link for the back arrow (last crumb that has a `to`)
  const parentCrumb = [...crumbs].reverse().find((c) => c.to && c.to !== pathname);
  const showBack = crumbs.length > 1 && parentCrumb?.to;

  return (
    <nav className="flex items-center gap-2 mb-4 text-[11px] font-[family-name:var(--font-mono)] tracking-wider uppercase text-[var(--color-fg-tertiary)]">
      {showBack && (
        <Link
          to={parentCrumb.to!}
          className="flex items-center hover:text-[var(--color-fg)] transition-colors mr-1"
          aria-label="Back"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </Link>
      )}
      {crumbs.map((crumb, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <span>/</span>}
          {crumb.to ? (
            <Link
              to={crumb.to}
              className="hover:text-[var(--color-fg)] transition-colors"
            >
              {crumb.label}
            </Link>
          ) : (
            <span className="text-[var(--color-fg)]">{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
